/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton } from 'react-toolbox/lib/button';
import { CardTitle } from 'react-toolbox/lib/card';
import theme from './styles.scss';
import XyzzyDialog from './XyzzyDialog';

type Props = {
    value: ?string,
    onChange?: (value: string) => void,
    defaultVisible?: boolean
};

const XyzzyConfigDialog = ({
    value,
    onChange,
    defaultVisible = false
}: Props): React.Node => {
    const { t } = useTranslation();

    const handleMouseDown = event => {
        event.stopPropagation();
    };

    const handleChange = event => {
        onChange?.(event.target.value);
    };

    return (
        <XyzzyDialog
            defaultVisible={defaultVisible}
            render={dialog => (
                <>
                    <CardTitle
                        title={t('configuration')}
                        avatar={
                            <IconButton
                                icon="close"
                                onClick={() => dialog.hide()}
                                theme={theme}
                            />
                        }
                        theme={theme}
                    />
                    <textarea
                        spellCheck="false"
                        type="text"
                        value={value}
                        onChange={handleChange}
                        className={theme.input}
                        onMouseDown={handleMouseDown}
                    />
                </>
            )}
        />
    );
};

export default XyzzyConfigDialog;
